/**
 * Generate port-specific cookie names for session isolation between different instances
 * This mirrors the backend AppUrlsHelper.cookie_name method
 */
export function cookieName(baseName: string): string {
  // Check if we're running in the browser (not during SSR)
  if (typeof window === 'undefined') {
    // During SSR, return the base name without port suffix
    return baseName
  }

  // Get the current port from the browser location
  const port = parseInt(window.location.port, 10)

  // Only include port suffix for non-standard ports (not 80/443)
  // This matches the backend logic in AppUrlsHelper.cookie_name
  if (port && port !== 80 && port !== 443) {
    return `${baseName}_${port}`
  } else {
    return baseName
  }
}
